/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { AnyAction } from 'redux';
import { acciones, IEstadoFlujosEtapas } from './interfaces';

export const estadoInicial: IEstadoFlujosEtapas = {
    entidadFlujosEtapas: null,
    estadoFormulario: false,
    recargarTabla: true,
    tipoFormulario: TipoFormulario.Creacion,
};

export const reductor = (estado: IEstadoFlujosEtapas, { type, payload }: AnyAction) => {
    switch (type) {
        case acciones.CAMBIAR_ESTADO_FORMULARIO: {
            return {
                ...estado,
                entidadFlujosEtapas: payload ? payload.entidadFlujosEtapas : null,
                estadoFormulario: !estado.estadoFormulario,
                tipoFormulario: payload ? payload.tipoFormulario : estado.tipoFormulario,
            };
        }
        case acciones.RECARGAR_TABLA:
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };

        default:
            return estado;
    }
};
